// src/components/lessons/renderers/OrderedListRenderer.jsx
import React, { useState } from 'react';

const OrderedListRenderer = ({ block, isMobile }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{ fontWeight: '700', color: '#000000' }}>
          {part}
        </strong>
      ) : part;
    });
  };

  return (
    <ol style={{
      listStyle: 'none',
      padding: 0,
      margin: '1rem 0',
      counterReset: 'item'
    }}>
      {block.items.map((item, i) => (
        <li
          key={i}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '1rem',
            marginBottom: '1rem',
            color: '#000000',
            lineHeight: '1.7',
            fontSize: isMobile ? '0.95rem' : '1rem',
            counterIncrement: 'item',
            padding: '0.75rem',
            marginLeft: '-0.75rem',
            marginRight: '-0.75rem',
            borderRadius: '0.5rem',
            background: hoveredIndex === i ? '#F9FAFB' : 'transparent',
            transition: 'all 0.2s ease',
            cursor: 'default',
            opacity: hoveredIndex === i ? 1 : 0.9
          }}
          onMouseEnter={() => setHoveredIndex(i)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: hoveredIndex === i ? '#000000' : '#3A86FF',
            color: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            fontSize: '0.875rem',
            flexShrink: 0,
            transition: 'all 0.3s ease',
            transform: hoveredIndex === i ? 'scale(1.1) rotate(12deg)' : 'scale(1) rotate(0deg)'
          }}>
            {i + 1}
          </div>
          <span style={{ flex: 1 }}>
            {processText(item)}
          </span>
          {hoveredIndex === i && (
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#3A86FF',
              marginTop: '0.5rem',
              flexShrink: 0
            }} />
          )}
        </li>
      ))}
    </ol>
  );
};

export default OrderedListRenderer;